import { ENDPOINT } from '~/constants';

import { type KyRequestOptions } from '@vestigas/data';

import { vestigasApi } from '~/services/kyClient';

import {
  TopSitesBreakdownQueryParams,
  TopSitesBreakdownResponse,
} from './types';
import {
  zodTopSitesBreakdownEndpointSchema,
  zodTopSitesBreakdownQueryParamsSchema,
  zodTopSitesBreakdownResponseSchema,
} from './validations';

/**
 * Fetches the top sites breakdown data from the API with the given query parameters.
 *
 * @param queryParams - The query parameters for fetching the top sites breakdown.
 * @param options - Additional options for the request (e.g., abort signal).
 * @returns The top sites breakdown data.
 * @throws Error if the API request fails.
 * @see https://app.dev.vestigas.com/redoc#tag/Site/operation/get_top_sites_breakdown_site_statistics_top_sites_post
 */
export const fetchTopSitesBreakdown = async (
  queryParams: TopSitesBreakdownQueryParams,
  options?: KyRequestOptions,
) => {
  const response = await vestigasApi
    .post(ENDPOINT.ANALYTICS.GET_TOP_SITES_BREAKDOWN(), {
      json: queryParams,
      validate: {
        body: zodTopSitesBreakdownQueryParamsSchema,
        pathSegments: zodTopSitesBreakdownEndpointSchema,
      },
      ...options,
    })
    .json<TopSitesBreakdownResponse>();

  // Validate the response
  const validatedResponse = zodTopSitesBreakdownResponseSchema.parse(response);

  return validatedResponse;
};
